import type SaleRequestModel from 'ab-requestModels/sale.requestModel';

import { isValidPhoneNumber } from '@acceligentllc/shared/utils/phone';
import { isValidTextInput } from '@acceligentllc/shared/utils/text';
import { isValidNumber } from '@acceligentllc/shared/utils/validation';

import { EMAIL_REGEX } from '@acceligentllc/shared/constants/regex';

export function validate(values: SaleRequestModel) {
	const errors: ValidationErrors = {};

	if (!isValidTextInput(values.fullName)) {
		errors.fullName = 'Full name is required';
	}

	if (!isValidTextInput(values.title)) {
		errors.title = 'Title is required';
	}

	if (!values.faxCountryCode) {
		errors.faxCountryCode = 'Country code is required';
	}

	if (values.fax && !isValidPhoneNumber(values.fax)) {
		errors.fax = 'Invalid fax';
	}

	if (!values.phoneCountryCode) {
		errors.phoneCountryCode = 'Country code is required';
	}

	if (!values.phone) {
		errors.phone = 'Mobile phone is required';
	} else if (!isValidPhoneNumber(values.phone)) {
		errors.phone = 'Invalid mobile phone';
	}

	if (!values.email) {
		errors.email = 'Email is required';
	} else if (!EMAIL_REGEX.test(values.email)) {
		errors.email = 'Invalid email';
	}

	if (!isValidTextInput(values.street)) {
		errors.street = 'Location required';
	}

	if (!isValidTextInput(values.locality!)) {
		errors.locality = 'City required';
	}

	if (!isValidTextInput(values.aa1!)) {
		errors.aa1 = 'State required';
	}

	if (!isValidTextInput(values.postalCode!)) {
		errors.postalCode = 'Zip required';
	}

	if (!isValidTextInput(values.country!)) {
		errors.country = 'Country required';
	}

	return errors;
}

export function warn(values: SaleRequestModel) {
	const warnings: ValidationErrors = {};
	if (!isValidNumber(values.latitude) || !isValidNumber(values.latitude)) {
		warnings.street = 'Location is not recognized by Google Maps.';
	}
	return warnings;
}
